// The single-active-session LoginId for v1. Per-device, minted by the
// backend: it lands in the /auth-check response for a flagged user and is
// sent back on subsequent /auth-check calls as the x-login-id header.
// Stored in localStorage so it survives reloads and is shared across tabs
// of the same browser (one device = one login). Unflagged users never get
// one. Mirrors v2's currentUser.login.ts semantics, but the v1 login lives
// in v1's own crm.UserLogins pool (keyed by crm.Users.Id).

const LOGIN_ID_KEY = "placepoint:loginId"

export function getLoginId(): string | null {
  return localStorage.getItem(LOGIN_ID_KEY)
}

export function setLoginId(loginId: string): void {
  localStorage.setItem(LOGIN_ID_KEY, loginId)
}

export function clearLoginId(): void {
  localStorage.removeItem(LOGIN_ID_KEY)
}
